import i18n from 'i18next';

export const SOURCE_WARNINGS = {
	traffic: i18n.t(`The traffic types don't match the offer requirements.`),
	geo: i18n.t('Geo does not match the offer requirements'),
};
